import { render, staticRenderFns } from "./JacRegionBoardMembersAssign.vue?vue&type=template&id=a9e3544e"
import script from "./JacRegionBoardMembersAssign.vue?vue&type=script&lang=js"
export * from "./JacRegionBoardMembersAssign.vue?vue&type=script&lang=js"
import style0 from "./JacRegionBoardMembersAssign.vue?vue&type=style&index=0&id=a9e3544e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports